<template>
  <tbody>
    <tr class="text-xs-center hovereable" v-for="(item, i) in items" :key="i" @click="getCustomer($event, item.id)">
      <td width="120">
        <v-icon x-large class="k-orange-linear-text text--darken-2">fas fa-user</v-icon>
      </td>
      <td width="500" style="max-width: 500px;" class="text-xs-left">
        <p class="break-all">
          {{ item.name ? item.name : 'Sin especificar' }}
        </p>
        <small>Cuenta: {{ item.account ? item.account : 'Sin especificar' }}</small>
      </td>
      <td>
        <v-chip 
          class="transparent white--text span-customer">
          {{item.status ? item.status.status : 'Sin estado'}}
          <v-icon class="x-small-icon pl-2">
            {{ `fas fa-${icons[item.status.status] || 'times-circle'}` }}
          </v-icon>
        </v-chip>
      </td>
      <td>
        <v-chip 
          class="transparent white--text span-customer">
          {{ subStatus(item.sub_status_id).name || 'Sin información' }}
        </v-chip>
      </td>
      <td class="text-xs-right">
        <v-menu left offset-x>
          <v-btn color="black" icon flat slot="activator">
            <v-icon small>fas fa-ellipsis-v</v-icon>
          </v-btn>
          <v-list>
            <v-list-tile @click="openModal(item.id, 'phone')">
              <v-list-tile-title>Telefonos</v-list-tile-title>
            </v-list-tile>
            <v-list-tile @click="openModal(item.id, 'email')">
              <v-list-tile-title>Emails</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </td>
    </tr>
  </tbody>
</template>

<script>
import EventBus from '@/event-bus';
import dataTableListMixin from '@/mixins/dataTableList';
import { mapGetters } from 'vuex';

export default {
  mixins: [dataTableListMixin],
  data() {
    return {
      showUrl: 'customer',
      icons: {
        Abono: 'hand-holding-usd',
        'Buzon de Voz': 'user-times',
        Cesante: 'inbox',
        Compromiso: 'calendar-check',
        Contenido: 'inbox',
        Conectado: 'headset',
        Detenido: 'hand-paper',
        'Desconoce deuda': 'user-minus',
        Error: 'times',
        Enviado: 'check',
        'En Proceso': 'clock',
        Equivocado: 'user-slash',
        Entregado: 'user-check',
        'Fuera de horario': 'clock',
        Gestionando: 'cogs',
        Incidencia: 'times',
        Invalido: 'times',
        'Llamar luego': 'history',
        Leido: 'book-open',
        'No contesta': 'user-clock',
        'No entregado': 'comment-slash',
        Ocupado: 'ban',
        Pagado: 'hand-holding-usd',
        'Por gestionar': 'clock',
        Programado: 'clipboard-check',
        'Por eliminar': 'trash',
        Rebotado: 'voice_over_off',
        Rechazado: 'bell-slash',
        'Sin compromiso': 'calendar-times',
        'Sin contatco digital': 'times-circle',
        'Saldo bajo': 'coins',
      },
    };
  },
  mounted() {
    /* eslint-disable */
    String.prototype.toPascalCase = function () {
      return this.match(/[a-z]+/gi)
        .map(function (word) {
          return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase()
        })
        .join('');
    };
  },
  computed: {
    ...mapGetters([
      'subStatus',
    ]),
  },
  methods: {
    setStatus(status) {
      if (['Abono', 'Compromiso', 'Contenido'].includes(status)) {
        return 'green';
      } else if (['Por gestionar', 'Llamar luego'].includes(status)) {
        return 'blue';
      } else if (status == 'Gestionando') {
        return 'orange';
      } else {
        return 'red';
      }
    },
    statusItem(id, stat) {
      this.axios.patch(`/customers/${id}`, {
        status: stat,
      }).then(() => {
        EventBus.$emit('update', true);
      });
    },
    openModal(id, type) {
      this.axios.get(`/customers/${id}?fields=customer${type.toPascalCase()}s.${type},customer${type.toPascalCase()}s.status,customer${type.toPascalCase()}s.priority,customer${type.toPascalCase()}s.type&sort=-customer${type.toPascalCase()}s.priority&paginate=0`).then((response) => {
        EventBus.$emit('openModal', response.data[`customer_${type}s`], type);
      });
    },
    getCustomer($event, id) {
      if (!$event || $event.target.className !== 'btn__content') {
        this.$router.push(`/customers/${id}/show`)
      }
    },
  },
};
</script>
<style  scoped>
  .span-customer {
    color: #000!important;
    border: 1px solid #000!important;
  }

</style>


// WEBPACK FOOTER //
// src/components/customer/CustomersList.vue